import { WS } from './actionCases';

class WebsocketEventEmitter {
	constructor () {
		this.subscribers = {};
		this.ws = null;
		this.dispatch = null;
	}

	setDispatch = dispatch => this.dispatch = dispatch;

	setWs = ws => this.ws = ws;

	closeWs = async () => {
		this.ws = null;
		await this.dispatch({ type: WS.CLOSE });
	};

	isSubscriber = reqId => (this.subscribers[reqId]) ? true : false;

	publish = (eventName, data) => {
		if (!Array.isArray(this.subscribers[eventName])) return;
		this.subscribers[eventName].forEach((callback) => {
			callback({
				reqId: eventName,
				data
			});
		});
	};

	subscribe = (eventName, callback) => {
		if (!Array.isArray(this.subscribers[eventName])) this.subscribers[eventName] = [];
		this.subscribers[eventName].push(callback);
	};

	unsubscribe = eventName => delete this.subscribers[eventName];
}

export default new WebsocketEventEmitter();